import axios from "axios";
import { MAIN_URL } from "../Configurations/Urls";

export async function fetchOrganizationLevels(orgId) {
  const response = await axios.get(
    `${MAIN_URL}/api/organizations/${orgId}/organization-level`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return response.data?.Levels || response.data?.data || [];
}
